import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useState } from 'react';
import useApiUrl from '../../framework/hooks/useApiUrlHook';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

export default function NieuwsbriefForm() {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const apiUrl = useApiUrl();

    const [page, setPage] = useState('form');

    const onSubmit = async (data) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const grecaptchaToken = await executeRecaptcha('yourAction');

        const send = { ...data, grecaptchaToken };

        if (apiUrl === null) return;

        await axios.post(`${apiUrl}/form/nieuwsbrief`, send).then((response) => {
            if (response.data.success) {
                setPage('bedankt');
            } else {
                setPage('failed');
            }
        });

        console.log(data);
    };

    return (
        <div className="newsletter-wrap">
            <h3>
                Meld je aan voor onze nieuwsbrief<span>.</span>
            </h3>
            {(page === 'form') ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="input-wrap">
                        <input
                            type="email"
                            placeholder="Jouw e-mailadres"
                            autoComplete="off"
                            className={errors.email ? 'is-invalid' : ''}
                            {...register('email', { required: 'Vul een mailadres in' })}
                        />
                        {errors.email ? <div className="invalid-feedback">{errors.email.message}</div> : ''}
                        <button type="submit">Aanmelden</button>
                    </div>
                </form>
            ) : (
                <p>Bedankt voor het aanmelden voor onze nieuwsbrief</p>
            )}
        </div>
    );
}
